__turbopack_context__.v({
  "soonBadge": "ClubProfileTabs-module-scss-module__AxVPyG__soonBadge",
  "tabSoon": "ClubProfileTabs-module-scss-module__AxVPyG__tabSoon",
});
